import { useState, useRef, useCallback, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";
const WEBHOOK_URL = `${API_BASE}/strategies/api/webhook/tradingview/`;
const CLEANUP_URL = `${API_BASE}/strategies/api/test-cleanup/`;

const STRATEGY_REGISTRY = {
  // ── RTH 45s ───────────────────────────────────────────────
  "QQQ-RTH-SHORT-931-959-TEST": {
    label: "QQQ Short 9:31 – 9:59 AM",
    badge: "RTH 9:31 AM",
    color: "#e05252",
    direction: "SHORT",
    asset: "QQQ",
    timeframe: "45s",
    trading_hour: "RTH",
    description: "C1: SMART_BAND_15 (22–64m) · C2: COBRA_LONG_12_SLOW (19–214m) → SMART_BAND_15_SHORT",
    conditions: [
      { id: "C1", label: "SMART_BAND_15", window: "22 – 64 min before trigger" },
      { id: "C2", label: "COBRA_LONG_12_SLOW", window: "19 – 214 min before trigger" },
    ],
    signals: [
      { id: "s1", label: "COBRA_LONG_12_SLOW", signal: "COBRA_LONG_12_SLOW", role: "CONFIRMATION", condition: "C2", description: "C2 · 19–214 min before trigger", offset_minutes: -60, price: 500000.00, delay_ms: 0 },
      { id: "s2", label: "SMART_BAND_15", signal: "SMART_BAND_15", role: "CONFIRMATION", condition: "C1", description: "C1 · 22–64 min before trigger", offset_minutes: -30, price: 500010.00, delay_ms: 2000 },
      { id: "s3", label: "SMART_BAND_15_SHORT", signal: "SMART_BAND_15_SHORT", role: "TRIGGER", condition: "TRIGGER", description: "Fires SHORT entry", offset_minutes: 0, price: 500020.00, delay_ms: 3000 },
      { id: "s4", label: "SMART_BAND_15 (Exit)", signal: "SMART_BAND_15", role: "EXIT", condition: "EXIT", description: "Closes SHORT · +2 min (clears exit gap)", offset_minutes: 2, price: 499500.00, delay_ms: 15000 },
    ],
  },
  "QQQ-RTH-SHORT-1000-1059-TEST": {
    label: "QQQ Short 10:00 – 10:59 AM",
    badge: "RTH 10:00 AM",
    color: "#e07c30",
    direction: "SHORT",
    asset: "QQQ",
    timeframe: "45s",
    trading_hour: "RTH",
    description: "C1: COBRA_SHORT_12_SLOW (0–5m) · C2: COBRA_LONG_12_SLOW (9–48m) → SMART_BAND_15_SHORT",
    conditions: [
      { id: "C1", label: "COBRA_SHORT_12_SLOW", window: "0 – 5 min before trigger" },
      { id: "C2", label: "COBRA_LONG_12_SLOW", window: "9 – 48 min before trigger" },
    ],
    signals: [
      { id: "s1", label: "COBRA_LONG_12_SLOW", signal: "COBRA_LONG_12_SLOW", role: "CONFIRMATION", condition: "C2", description: "C2 · 9–48 min before trigger", offset_minutes: -20, price: 500000.00, delay_ms: 0 },
      { id: "s2", label: "COBRA_SHORT_12_SLOW", signal: "COBRA_SHORT_12_SLOW", role: "CONFIRMATION", condition: "C1", description: "C1 · 0–5 min before trigger", offset_minutes: -3, price: 500010.00, delay_ms: 2000 },
      { id: "s3", label: "SMART_BAND_15_SHORT", signal: "SMART_BAND_15_SHORT", role: "TRIGGER", condition: "TRIGGER", description: "Fires SHORT entry", offset_minutes: 0, price: 500020.00, delay_ms: 3000 },
      { id: "s4", label: "SMART_BAND_15 (Exit)", signal: "SMART_BAND_15", role: "EXIT", condition: "EXIT", description: "Closes SHORT · +2 min (clears exit gap)", offset_minutes: 2, price: 499500.00, delay_ms: 15000 },
    ],
  },

  // ── ETH 45s ───────────────────────────────────────────────
  "QQQ-ETH-SHORT-931-959-TEST": {
    label: "QQQ ETH Short 9:31 – 9:59 AM",
    badge: "ETH 9:31 AM",
    color: "#5b8dee",
    direction: "SHORT",
    asset: "QQQ",
    timeframe: "45s",
    trading_hour: "ETH",
    description: "C1: SMART_BAND_15 (22–64m) · C2: COBRA_LONG_12_SLOW (19–214m) → SMART_BAND_15_SHORT",
    conditions: [
      { id: "C1", label: "SMART_BAND_15", window: "22 – 64 min before trigger" },
      { id: "C2", label: "COBRA_LONG_12_SLOW", window: "19 – 214 min before trigger" },
    ],
    signals: [
      {
        id: "s1", label: "COBRA_LONG_12_SLOW", signal: "COBRA_LONG_12_SLOW",
        role: "CONFIRMATION", condition: "C2",
        description: "C2 · 19–214 min before trigger",
        offset_minutes: -60, price: 500000.00, delay_ms: 0,
        // Webhook payload: { signal: "COBRA_LONG_12_SLOW", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s2", label: "SMART_BAND_15", signal: "SMART_BAND_15",
        role: "CONFIRMATION", condition: "C1",
        description: "C1 · 22–64 min before trigger",
        offset_minutes: -30, price: 500010.00, delay_ms: 2000,
        // Webhook payload: { signal: "SMART_BAND_15", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s3", label: "SMART_BAND_15_SHORT", signal: "SMART_BAND_15_SHORT",
        role: "TRIGGER", condition: "TRIGGER",
        description: "Fires SHORT entry",
        offset_minutes: 0, price: 500020.00, delay_ms: 3000,
        // Webhook payload: { signal: "SMART_BAND_15_SHORT", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s4", label: "SMART_BAND_15 (Exit)", signal: "SMART_BAND_15",
        role: "EXIT", condition: "EXIT",
        description: "Closes SHORT · +2 min (clears exit gap)",
        offset_minutes: 2, price: 499500.00, delay_ms: 15000,
        // Webhook payload: { signal: "SMART_BAND_15", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
    ],
  },
  "QQQ-ETH-SHORT-1000-1059-TEST": {
    label: "QQQ ETH Short 10:00 – 10:59 AM",
    badge: "ETH 10:00 AM",
    color: "#7c5bee",
    direction: "SHORT",
    asset: "QQQ",
    timeframe: "45s",
    trading_hour: "ETH",
    description: "C1: COBRA_SHORT_12_SLOW (0–5m) · C2: COBRA_LONG_12_SLOW (9–48m) → SMART_BAND_15_SHORT",
    conditions: [
      { id: "C1", label: "COBRA_SHORT_12_SLOW", window: "0 – 5 min before trigger" },
      { id: "C2", label: "COBRA_LONG_12_SLOW", window: "9 – 48 min before trigger" },
    ],
    signals: [
      {
        id: "s1", label: "COBRA_LONG_12_SLOW", signal: "COBRA_LONG_12_SLOW",
        role: "CONFIRMATION", condition: "C2",
        description: "C2 · 9–48 min before trigger",
        offset_minutes: -20, price: 500000.00, delay_ms: 0,
        // Webhook payload: { signal: "COBRA_LONG_12_SLOW", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s2", label: "COBRA_SHORT_12_SLOW", signal: "COBRA_SHORT_12_SLOW",
        role: "CONFIRMATION", condition: "C1",
        description: "C1 · 0–5 min before trigger",
        offset_minutes: -3, price: 500010.00, delay_ms: 2000,
        // Webhook payload: { signal: "COBRA_SHORT_12_SLOW", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s3", label: "SMART_BAND_15_SHORT", signal: "SMART_BAND_15_SHORT",
        role: "TRIGGER", condition: "TRIGGER",
        description: "Fires SHORT entry",
        offset_minutes: 0, price: 500020.00, delay_ms: 3000,
        // Webhook payload: { signal: "SMART_BAND_15_SHORT", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s4", label: "SMART_BAND_15 (Exit)", signal: "SMART_BAND_15",
        role: "EXIT", condition: "EXIT",
        description: "Closes SHORT · +2 min (clears exit gap)",
        offset_minutes: 2, price: 499500.00, delay_ms: 15000,
        // Webhook payload: { signal: "SMART_BAND_15", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
    ],
  },
  "QQQ-ETH-SHORT-8AM-11AM-TEST": {
    label: "QQQ ETH Short 8AM – 11AM",
    badge: "ETH 8–11 AM",
    color: "#3db88a",
    direction: "SHORT",
    asset: "QQQ",
    timeframe: "45s",
    trading_hour: "ETH",
    description: "C1: sequence COBRA_LONG→SMARTBAND15_SHORT (excl. COBRA_SHORT) · R1: SMART_BAND_15 time_window 29–38m",
    conditions: [
      { id: "C1", label: "COBRA_LONG_12_SLOW", window: "sequence before trigger, no COBRA_SHORT between" },
      { id: "R1", label: "SMART_BAND_15", window: "signal_a 29–38 min before trigger (time_window)" },
    ],
    signals: [
      {
        id: "s1", label: "COBRA_LONG_12_SLOW", signal: "COBRA_LONG_12_SLOW",
        role: "CONFIRMATION", condition: "C1",
        description: "C1 · sequence before trigger, no COBRA_SHORT_12_SLOW between",
        offset_minutes: -60, price: 500000.00, delay_ms: 0,
        // Webhook payload: { signal: "COBRA_LONG_12_SLOW", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s2", label: "SMART_BAND_15", signal: "SMART_BAND_15",
        role: "CONFIRMATION", condition: "R1",
        description: "R1 · time_window signal_a: 29–38 min before trigger",
        offset_minutes: -33, price: 500010.00, delay_ms: 2000,
        // Webhook payload: { signal: "SMART_BAND_15", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s3", label: "SMART_BAND_15_SHORT", signal: "SMART_BAND_15_SHORT",
        role: "TRIGGER", condition: "TRIGGER",
        description: "Fires SHORT entry",
        offset_minutes: 0, price: 500020.00, delay_ms: 3000,
        // Webhook payload: { signal: "SMART_BAND_15_SHORT", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
      {
        id: "s4", label: "SMART_BAND_15 (Exit)", signal: "SMART_BAND_15",
        role: "EXIT", condition: "EXIT",
        description: "Closes SHORT · +2 min (clears exit gap)",
        offset_minutes: 2, price: 499500.00, delay_ms: 15000,
        // Webhook payload: { signal: "SMART_BAND_15", timeframe: "45s", asset: "QQQ", trading_hour: "ETH" }
      },
    ],
  },
};

// ─────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────
const ROLE_STYLES = {
  CONFIRMATION: { color: "#4db8cc", bg: "rgba(77,184,204,0.1)", border: "rgba(77,184,204,0.25)" },
  TRIGGER:      { color: "#a78bfa", bg: "rgba(167,139,250,0.1)", border: "rgba(167,139,250,0.3)" },
  EXIT:         { color: "#f87171", bg: "rgba(248,113,113,0.1)", border: "rgba(248,113,113,0.25)" },
};

const STATUS = {
  pending:   { icon: null,  color: "#444", label: "Pending" },
  waiting:   { icon: "◔",  color: "#f59e0b", label: "Waiting..." },
  sending:   { icon: "◌",  color: "#4db8cc", label: "Sending..." },
  analyzing: { icon: "⟳",  color: "#a78bfa", label: "Analyzing..." },
  success:   { icon: "✓",  color: "#4ade80", label: "Sent" },
  error:     { icon: "✗",  color: "#f87171", label: "Failed" },
  deleted:   { icon: "⊘",  color: "#555",    label: "Deleted" },
};

const LOG_COLOR = { info: "#555", action: "#4db8cc", success: "#4ade80", error: "#f87171", warn: "#f59e0b" };

// ─────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────
function hexRgb(hex) {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return r ? `${parseInt(r[1],16)},${parseInt(r[2],16)},${parseInt(r[3],16)}` : "255,255,255";
}
function applyOffset(anchor, mins) {
  return new Date(anchor.getTime() + mins * 60000).toISOString();
}
function fmtOffset(m) {
  if (m === 0) return "now (trigger)";
  return m < 0 ? `${Math.abs(m)}m before trigger` : `${m}m after trigger`;
}
function fmtTs(iso) { return iso ? iso.slice(11, 19) + " UTC" : "—"; }

// ─────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────
export default function StrategyTestLauncher() {
  const [selectedId, setSelectedId]     = useState(null);
  const [offsets, setOffsets]           = useState({});
  const [prices, setPrices]             = useState({});
  const [signalStates, setSignalStates] = useState({});
  const [isRunning, setIsRunning]       = useState(false);
  const [runComplete, setRunComplete]   = useState(false);
  const [isDeleting, setIsDeleting]     = useState(false);
  const [log, setLog]                   = useState([]);
  const [anchor, setAnchor]             = useState(null);
  const abortRef    = useRef(false);
  const intervalRef = useRef({});
  const signalIds   = useRef({});
  const logEnd      = useRef(null);

  useEffect(() => { logEnd.current?.scrollIntoView({ behavior: "smooth" }); }, [log]);

  useEffect(() => {
    if (!selectedId) return;
    const cfg = STRATEGY_REGISTRY[selectedId];
    const off = {}, pr = {}, st = {};
    cfg.signals.forEach(s => {
      off[s.id] = s.offset_minutes;
      pr[s.id]  = s.price;
      st[s.id]  = { status: "pending", signalId: null, countdown: 0 };
    });
    setOffsets(prev => ({ ...prev, [selectedId]: off }));
    setPrices(prev  => ({ ...prev, [selectedId]: pr }));
    setSignalStates(st);
    setLog([]);
    setRunComplete(false);
    setAnchor(null);
    signalIds.current = {};
  }, [selectedId]);

  const addLog = useCallback((msg, type = "info") => {
    const ts = new Date().toLocaleTimeString("en-US", { hour12: false });
    setLog(p => [...p, { ts, msg, type }]);
  }, []);

  const setSignal = useCallback((id, patch) => {
    setSignalStates(p => ({ ...p, [id]: { ...p[id], ...patch } }));
  }, []);

  const sleep = ms => new Promise(r => setTimeout(r, ms));

  const runAnalyzer = async (stratId) => {
    try {
      const res  = await fetch(`${API_BASE}/strategies/analyze/${stratId}/?broadcast=true`, {
        method: "GET", headers: { "Content-Type": "application/json" }, credentials: "include",
      });
      const data = await res.json();
      if (data.error) { addLog(`❌ Analyzer error: ${data.error}`, "error"); return null; }
      const s = data.summary || {};
      addLog(`📡 Analyzer → ${s.completed_trades ?? 0} completed · ${s.open_trades ?? 0} open · ${s.pending_trades ?? 0} pending`, "success");
      (data.trades || []).forEach(t => {
        if (t.status === "open")
          addLog(`   ↳ OPEN: entry ${t.entry_time?.slice(11,19) || "?"} · $${t.entry_price?.toLocaleString() || "?"}`, "success");
        if (t.status === "completed") {
          const pnl = t.pnl != null ? (t.pnl >= 0 ? `+${t.pnl.toFixed(2)}` : t.pnl.toFixed(2)) : "?";
          addLog(`   ↳ COMPLETED: ${t.entry_time?.slice(11,19)||"?"} → ${t.exit_time?.slice(11,19)||"?"} · PnL ${pnl}`, t.pnl > 0 ? "success" : "error");
        }
      });
      return data;
    } catch (e) { addLog(`⚠️ Analyzer error: ${e.message}`, "warn"); return null; }
  };

  const sendWebhook = async (signal, cfg, timestamp, price) => {
    setSignal(signal.id, { status: "sending" });
    // Payload always uses cfg.timeframe and cfg.trading_hour from the registry
    const payload = {
      signal: signal.signal,
      timeframe: cfg.timeframe,
      asset: cfg.asset,
      price,
      signal_timestamp: timestamp,
      trading_hour: cfg.trading_hour,
    };
    addLog(`→ ${signal.label}  ts: ${fmtTs(timestamp)}  $${price.toLocaleString()}`, "action");
    try {
      const res  = await fetch(WEBHOOK_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      const data = await res.json();
      if (data.success) {
        const sid = data.database?.signal_id;
        signalIds.current[signal.id] = sid;
        setSignal(signal.id, { status: "success", signalId: sid });
        addLog(`✓ ${signal.label} stored · DB #${sid}`, "success");
        return { ok: true };
      } else {
        setSignal(signal.id, { status: "error" });
        addLog(`✗ ${signal.label}: ${data.error || "unknown error"}`, "error");
        return { ok: false };
      }
    } catch (e) {
      setSignal(signal.id, { status: "error" });
      addLog(`✗ ${signal.label}: ${e.message}`, "error");
      return { ok: false };
    }
  };

  const startCountdown = (id, secs) => {
    let rem = secs;
    setSignal(id, { status: "waiting", countdown: rem });
    intervalRef.current[id] = setInterval(() => {
      rem -= 1;
      if (rem <= 0) { clearInterval(intervalRef.current[id]); setSignal(id, { countdown: 0 }); }
      else setSignal(id, { countdown: rem });
    }, 1000);
  };

  const cleanupSignals = async (timeframe, asset) => {
    addLog("🧹 Cleaning test signals...", "action");
    try {
      const res  = await fetch(CLEANUP_URL, { method: "DELETE", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ timeframe, asset }) });
      const data = await res.json();
      if (data.success) addLog(`🧹 Deleted ${data.deleted_count} signals from ${data.table}`, data.deleted_count > 0 ? "success" : "info");
      else addLog(`⚠️ Cleanup: ${data.error}`, "warn");
    } catch (e) { addLog(`⚠️ Cleanup: ${e.message}`, "warn"); }
  };

  const runSequence = async () => {
    if (!selectedId) return;
    const cfg    = STRATEGY_REGISTRY[selectedId];
    const offMap = offsets[selectedId] || {};
    const prMap  = prices[selectedId]  || {};

    setIsRunning(true);
    setRunComplete(false);
    abortRef.current = false;
    setLog([]);
    signalIds.current = {};

    const initSt = {};
    cfg.signals.forEach(s => { initSt[s.id] = { status: "pending", signalId: null, countdown: 0 }; });
    setSignalStates(initSt);

    const now = new Date();
    setAnchor(now);

    addLog(`══ ${cfg.label} ══`, "action");
    addLog(`${cfg.direction} · ${cfg.asset} · ${cfg.timeframe} · ${cfg.trading_hour}`, "info");
    addLog(`Anchor: ${fmtTs(now.toISOString())}`, "info");
    addLog("", "info");

    await cleanupSignals(cfg.timeframe, cfg.asset);
    if (abortRef.current) { setIsRunning(false); setRunComplete(true); return; }

    addLog("▶ Launching signal sequence...", "action");
    addLog("", "info");

    for (let i = 0; i < cfg.signals.length; i++) {
      if (abortRef.current) { addLog("⚠️ Sequence aborted", "warn"); break; }
      const sig    = cfg.signals[i];
      const offset = offMap[sig.id] ?? sig.offset_minutes;
      const price  = prMap[sig.id]  ?? sig.price;
      const ts     = applyOffset(now, offset);

      if (sig.delay_ms > 0) {
        const secs = sig.delay_ms / 1000;
        addLog(`⏳ ${secs}s before ${sig.label}...`, "info");
        startCountdown(sig.id, secs);
        await sleep(sig.delay_ms);
        if (abortRef.current) break;
      }

      const result = await sendWebhook(sig, cfg, ts, price);
      if (!result.ok && sig.role === "TRIGGER") { addLog("🛑 Trigger failed — aborting", "error"); break; }

      setSignal(sig.id, { status: "analyzing" });
      if (sig.role !== "CONFIRMATION") await sleep(1500);
      addLog(`🔄 Triggering analyzer (${sig.role})...`, "info");
      const analyzerData = await runAnalyzer(selectedId);

      if (sig.role === "TRIGGER") {
        const open = (analyzerData?.trades || []).filter(t => t.status === "open").length;
        if (open > 0) addLog("🎯 Trade OPEN confirmed!", "success");
        else          addLog("⚠️ No open trade — check offsets & conditions", "warn");
      }
      if (sig.role === "EXIT") {
        const done = (analyzerData?.trades || []).filter(t => t.status === "completed").length;
        if (done > 0) addLog("🏁 Trade COMPLETED confirmed!", "success");
      }

      setSignal(sig.id, { status: "success" });
      addLog("", "info");
    }

    setIsRunning(false);
    setRunComplete(true);
    addLog("── Sequence complete ──", "action");
  };

  const abortSequence = () => {
    abortRef.current = true;
    Object.values(intervalRef.current).forEach(clearInterval);
    addLog("🛑 Abort requested", "error");
  };

  const deleteAll = async () => {
    if (!selectedId) return;
    const cfg = STRATEGY_REGISTRY[selectedId];
    setIsDeleting(true);
    await cleanupSignals(cfg.timeframe, cfg.asset);
    cfg.signals.forEach(s => setSignal(s.id, { status: "deleted" }));
    setIsDeleting(false);
  };

  const resetAll = () => {
    if (!selectedId) return;
    const initSt = {};
    STRATEGY_REGISTRY[selectedId].signals.forEach(s => { initSt[s.id] = { status: "pending", signalId: null, countdown: 0 }; });
    setSignalStates(initSt);
    setLog([]);
    setRunComplete(false);
    setAnchor(null);
    signalIds.current = {};
  };

  const setOffset = (sigId, val) => setOffsets(p => ({ ...p, [selectedId]: { ...p[selectedId], [sigId]: parseInt(val) || 0 } }));
  const setPrice  = (sigId, val) => setPrices(p  => ({ ...p, [selectedId]: { ...p[selectedId], [sigId]: parseFloat(val) || 0 } }));

  const cfg     = selectedId ? STRATEGY_REGISTRY[selectedId] : null;
  const offMap  = selectedId ? (offsets[selectedId] || {}) : {};
  const prMap   = selectedId ? (prices[selectedId]  || {}) : {};
  const hasSent = cfg?.signals.some(s => signalStates[s.id]?.signalId);

  const rthStrategies = Object.entries(STRATEGY_REGISTRY).filter(([, c]) => c.trading_hour === "RTH");
  const ethStrategies = Object.entries(STRATEGY_REGISTRY).filter(([, c]) => c.trading_hour === "ETH");

  const renderCard = ([id, c]) => {
    const active = selectedId === id;
    const rgb    = hexRgb(c.color);
    return (
      <button key={id} onClick={() => { if (!isRunning) setSelectedId(id); }} style={{
        padding: "14px 16px", borderRadius: 8, textAlign: "left", cursor: isRunning ? "not-allowed" : "pointer",
        background: active ? `rgba(${rgb},0.07)` : "rgba(255,255,255,0.02)",
        border: `1px solid ${active ? c.color : "rgba(255,255,255,0.07)"}`,
        boxShadow: active ? `0 0 18px rgba(${rgb},0.12)` : "none",
        transition: "all 0.18s", opacity: isRunning && !active ? 0.5 : 1,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: active ? c.color : "#bbb" }}>{c.label}</span>
          <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 3, background: `rgba(${rgb},0.12)`, color: c.color, border: `1px solid rgba(${rgb},0.25)` }}>{c.badge}</span>
        </div>
        <div style={{ fontSize: 11, color: "#555", lineHeight: 1.5, marginBottom: 10 }}>{c.description}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {c.conditions.map(cond => (
            <span key={cond.id} style={{ fontSize: 10, padding: "2px 7px", borderRadius: 3, background: "rgba(77,184,204,0.08)", border: "1px solid rgba(77,184,204,0.2)", color: "#4db8cc" }}>
              {cond.id}: {cond.label}
            </span>
          ))}
        </div>
      </button>
    );
  };

  const sectionLabel = (text, color = "#444") => (
    <div style={{ fontSize: 10, fontWeight: 600, color, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>{text}</div>
  );

  return (
    <div style={{ maxWidth: 1080, margin: "0 auto", padding: "28px 24px", fontFamily: "system-ui, sans-serif", color: "#d4d4d4", background: "#0b0f18", minHeight: "100vh" }}>

      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#f87171", boxShadow: "0 0 6px #f87171" }} />
          <span style={{ fontSize: 17, fontWeight: 600, color: "#f0f0f0", letterSpacing: "-0.01em" }}>Strategy Test Launcher</span>
          <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 4, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#666" }}>QQQ · SHORT · 45s · RTH + ETH</span>
        </div>
        <p style={{ margin: "5px 0 0 17px", fontSize: 12, color: "#444" }}>
          Select a strategy, adjust offsets to satisfy condition windows, then launch.
        </p>
      </div>

      {/* Strategy Selector */}
      <div style={{ marginBottom: 22 }}>
        {sectionLabel("RTH Strategies")}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 10, marginBottom: 20 }}>
          {rthStrategies.map(renderCard)}
        </div>
        {sectionLabel("ETH Strategies", "#3db88a")}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 10 }}>
          {ethStrategies.map(renderCard)}
        </div>
      </div>

      {/* Main Panel */}
      {cfg && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 360px", gap: 18, alignItems: "start" }}>
          <div>
            {/* Condition reference */}
            <div style={{ marginBottom: 14, padding: "10px 14px", borderRadius: 6, background: "rgba(255,255,255,0.025)", border: "1px solid rgba(255,255,255,0.06)" }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: "#444", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Condition windows · {cfg.trading_hour} · {cfg.timeframe}</div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                {cfg.conditions.map(c => (
                  <div key={c.id} style={{ fontSize: 11, color: "#666" }}>
                    <span style={{ color: "#4db8cc", fontWeight: 600 }}>{c.id}</span>
                    <span style={{ color: "#444", margin: "0 4px" }}>·</span>
                    <span style={{ color: "#bbb" }}>{c.label}</span>
                    <span style={{ color: "#444", margin: "0 4px" }}>·</span>
                    <span style={{ color: "#777", fontStyle: "italic" }}>{c.window}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Anchor */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <span style={{ fontSize: 10, fontWeight: 600, color: "#444", textTransform: "uppercase", letterSpacing: "0.08em" }}>Signal pipeline</span>
              {anchor && <span style={{ fontSize: 11, color: "#555" }}>Anchor: <span style={{ color: "#a78bfa", fontFamily: "monospace" }}>{fmtTs(anchor.toISOString())}</span></span>}
            </div>

            {/* Signal cards */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              {cfg.signals.map((sig, idx) => {
                const st    = signalStates[sig.id] || { status: "pending", countdown: 0 };
                const stCfg = STATUS[st.status] || STATUS.pending;
                const rc    = ROLE_STYLES[sig.role];
                const off   = offMap[sig.id] ?? sig.offset_minutes;
                const pr    = prMap[sig.id]  ?? sig.price;
                const computedTs = anchor ? applyOffset(anchor, off) : null;
                const isLast = idx === cfg.signals.length - 1;

                return (
                  <div key={sig.id} style={{ display: "flex", gap: 10, alignItems: "stretch" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 32, flexShrink: 0 }}>
                      <div style={{
                        width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: stCfg.icon ? 13 : 11, fontWeight: 600,
                        background: st.status === "success" ? "rgba(74,222,128,0.1)" : st.status === "error" ? "rgba(248,113,113,0.1)" : st.status === "analyzing" ? "rgba(167,139,250,0.1)" : "rgba(255,255,255,0.03)",
                        border: `1.5px solid ${stCfg.color}`, color: stCfg.color, transition: "all 0.25s",
                      }}>
                        {stCfg.icon || (idx + 1)}
                      </div>
                      {!isLast && <div style={{ flex: 1, width: 1.5, minHeight: 14, background: st.status === "success" ? "rgba(74,222,128,0.2)" : "rgba(255,255,255,0.05)", transition: "background 0.3s" }} />}
                    </div>

                    <div style={{ flex: 1, padding: "12px 14px", borderRadius: 7, marginBottom: 8, background: rc.bg, border: `1px solid ${rc.border}`, opacity: st.status === "deleted" ? 0.3 : 1, transition: "opacity 0.3s" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#f0f0f0" }}>{sig.label}</span>
                          <span style={{ fontSize: 9, fontWeight: 700, padding: "1px 6px", borderRadius: 3, background: rc.bg, border: `1px solid ${rc.border}`, color: rc.color }}>{sig.condition}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          {st.countdown > 0 && <span style={{ fontSize: 12, fontWeight: 700, color: "#f59e0b" }}>{st.countdown}s</span>}
                          <span style={{ fontSize: 11, color: stCfg.color }}>{stCfg.label}</span>
                          {st.signalId && <span style={{ fontSize: 10, color: "#4ade80", fontFamily: "monospace" }}>#{st.signalId}</span>}
                        </div>
                      </div>
                      <div style={{ fontSize: 11, color: "#555", marginBottom: 10 }}>{sig.description}</div>
                      <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                          <span style={{ fontSize: 10, color: "#444" }}>Offset (min)</span>
                          <input type="number" value={off} disabled={isRunning} onChange={e => setOffset(sig.id, e.target.value)}
                            style={{ width: 56, padding: "3px 6px", fontSize: 11, fontWeight: 600, fontFamily: "monospace", borderRadius: 4, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: off < 0 ? "#f59e0b" : off > 0 ? "#4ade80" : "#a78bfa", cursor: isRunning ? "not-allowed" : "text" }}
                          />
                          <span style={{ fontSize: 10, color: off < 0 ? "#f59e0b" : off > 0 ? "#4ade80" : "#a78bfa", fontStyle: "italic" }}>{fmtOffset(off)}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                          <span style={{ fontSize: 10, color: "#444" }}>Price</span>
                          <input type="number" value={pr} disabled={isRunning} onChange={e => setPrice(sig.id, e.target.value)}
                            style={{ width: 80, padding: "3px 6px", fontSize: 11, fontFamily: "monospace", borderRadius: 4, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#bbb", cursor: isRunning ? "not-allowed" : "text" }}
                          />
                        </div>
                        {computedTs && <span style={{ fontSize: 10, color: "#444" }}>→ <span style={{ color: "#666", fontFamily: "monospace" }}>{fmtTs(computedTs)}</span></span>}
                        {sig.delay_ms > 0 && st.status === "pending" && <span style={{ fontSize: 10, color: "#444", fontStyle: "italic" }}>⏱ {sig.delay_ms / 1000}s delay</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Controls */}
            <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
              {!isRunning && !runComplete && (
                <button onClick={runSequence} style={{ padding: "10px 24px", borderRadius: 6, border: "none", cursor: "pointer", background: cfg.color, color: "#fff", fontSize: 13, fontWeight: 600, fontFamily: "inherit" }}>
                  ▲ Launch {cfg.direction} Sequence
                </button>
              )}
              {isRunning && (
                <button onClick={abortSequence} style={{ padding: "10px 24px", borderRadius: 6, border: "1px solid rgba(248,113,113,0.4)", cursor: "pointer", background: "rgba(248,113,113,0.1)", color: "#f87171", fontSize: 13, fontWeight: 600, fontFamily: "inherit" }}>■ Abort</button>
              )}
              {runComplete && hasSent && (
                <button onClick={deleteAll} disabled={isDeleting} style={{ padding: "10px 22px", borderRadius: 6, border: "1px solid rgba(248,113,113,0.35)", cursor: isDeleting ? "wait" : "pointer", background: "rgba(248,113,113,0.08)", color: "#f87171", fontSize: 13, fontWeight: 600, fontFamily: "inherit", opacity: isDeleting ? 0.5 : 1 }}>
                  {isDeleting ? "⏳ Deleting..." : "🗑 Delete Test Signals"}
                </button>
              )}
              {runComplete && (
                <button onClick={resetAll} style={{ padding: "10px 22px", borderRadius: 6, border: "1px solid rgba(255,255,255,0.08)", cursor: "pointer", background: "rgba(255,255,255,0.03)", color: "#666", fontSize: 13, fontWeight: 600, fontFamily: "inherit" }}>↺ Reset</button>
              )}
            </div>
          </div>

          {/* Log */}
          <div style={{ background: "rgba(0,0,0,0.35)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, overflow: "hidden", position: "sticky", top: 20 }}>
            <div style={{ padding: "9px 14px", borderBottom: "1px solid rgba(255,255,255,0.05)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 10, fontWeight: 600, color: "#444", textTransform: "uppercase", letterSpacing: "0.08em" }}>Activity Log</span>
              <span style={{ fontSize: 10, color: "#333" }}>{log.filter(l => l.msg).length} events</span>
            </div>
            <div style={{ height: 580, overflowY: "auto", padding: "6px 0", scrollbarWidth: "thin", scrollbarColor: "#1e1e1e transparent" }}>
              {log.length === 0
                ? <div style={{ padding: "40px 14px", textAlign: "center", color: "#2a2a2a", fontSize: 12 }}>Launch the sequence to see activity...</div>
                : log.map((e, i) => (
                    <div key={i} style={{ padding: "3px 14px 3px 13px", fontSize: 11, lineHeight: 1.65, display: "flex", gap: 8, borderLeft: `2px solid ${e.msg ? (LOG_COLOR[e.type] || "#333") : "transparent"}`, marginLeft: 6 }}>
                      {e.msg && <span style={{ color: "#2a2a2a", flexShrink: 0, fontFamily: "monospace" }}>{e.ts}</span>}
                      <span style={{ color: LOG_COLOR[e.type] || "#555" }}>{e.msg}</span>
                    </div>
                  ))
              }
              <div ref={logEnd} />
            </div>
          </div>
        </div>
      )}

      {!cfg && (
        <div style={{ textAlign: "center", padding: "60px 20px", color: "#2a2a2a", fontSize: 13, border: "1px dashed rgba(255,255,255,0.05)", borderRadius: 10 }}>
          ↑ Select a strategy above to begin
        </div>
      )}

      <style>{`
        input[type=number]::-webkit-inner-spin-button{opacity:.3}
        div::-webkit-scrollbar{width:3px}
        div::-webkit-scrollbar-thumb{background:#1e1e1e;border-radius:2px}
      `}</style>
    </div>
  );
}
